(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trunc-luxury-search-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('.trunc-search-section');
    if (!section) return;

    const endpoint = section.dataset.predictiveSearchUrl || '/search/suggest';

    const form = document.getElementById('trunc-predictive-search-form');
    if (!form) return;

    const visibleInput = document.getElementById('TruncLuxurySearch');
    const hiddenQuery = document.getElementById('TruncLuxurySearchQuery');
    const container = document.getElementById('trunc-predictive-container');
    if (!visibleInput || !hiddenQuery || !container) return;

    let timeoutId = null;

    // Build the q parameter on submit: tag filter + user term
    form.addEventListener('submit', function() {
      const term = visibleInput.value.trim();
      hiddenQuery.value = term.length
        ? term + ' tag:trunc-luxury-only'
        : 'tag:trunc-luxury-only';
    });

    // Predictive behaviour
    visibleInput.addEventListener('input', function() {
      const term = visibleInput.value.trim();

      if (!term.length) {
        container.innerHTML = '';
        container.hidden = true;
        return;
      }

      if (timeoutId) window.clearTimeout(timeoutId);

      timeoutId = window.setTimeout(function() {
        const url = new URL(endpoint, window.location.origin);
        // IMPORTANT: predictive q also includes tag: condition
        url.searchParams.set('q', term + ' tag:trunc-luxury-only');
        url.searchParams.set('section_id', 'predictive-search-luxury');

        fetch(url.toString(), {
          headers: {
            'Accept': 'text/html, application/xhtml+xml'
          }
        })
          .then(function(response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const sectionEl = doc.querySelector('#shopify-section-predictive-search-luxury');

            if (!sectionEl) {
              container.innerHTML = '';
              container.hidden = true;
              return;
            }

            container.innerHTML = sectionEl.innerHTML;
            container.hidden = false;
          })
          .catch(function() {
            container.innerHTML = '';
            container.hidden = true;
          });
      }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
